"use client";

import * as React from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Field, FieldLabel } from "@/components/ui/field";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";

interface DatePickerProps {
  value?: Date;
  onValueChange?: (date: Date | undefined) => void;
  label?: string | null;
  id?: string;
  className?: string;
}

export function DatePicker({ value, onValueChange, label, id = "date-picker", className }: DatePickerProps) {
  const [internalDate, setInternalDate] = React.useState<Date | undefined>();
  const isControlled = value !== undefined && onValueChange !== undefined;
  const date = isControlled ? value : internalDate;
  const setDate = isControlled ? onValueChange : setInternalDate;

  return (
    <Field className={className}>
      {label != null && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" id={id} className="justify-between gap-2">
            <CalendarIcon className="text-muted-foreground size-3.5" />
            {date ? format(date, "PPP") : <span>Select a date</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar mode="single" selected={date} onSelect={setDate} defaultMonth={date} />
        </PopoverContent>
      </Popover>
    </Field>
  );
}
